// 默认中文文字
const defaultTextEnum = {
    allText: '全部',
    mapFeatureText: '地图要素',
    mapShapePointText: '兴趣点位',

    toolMeasureDistanceText: '测距',
    toolMeasureAreaText: '测面',
    toolMeasureHeightText: '测高',
    toolShowLengthText: '显示每段长度',
    toolClearMessureResultText: '清除上次的测量结果',

    messureStartTipText: '鼠标单击开始绘制',
    distanceText: '距离',
    horizontalDistanceText: '水平距离',
    verticalDistanceText: '垂直距离',
    straightLineDistanceText: '直线距离',
    totalDistanceText: '总距离',
    areaText: '面积',

    totalText: '共',
    unitGeText: '个',
    pointText: '点位',
    scaleToText: '缩放至',
    nameText: '名称',
    operationText: '操作',
    positionText: '定位',

    chooseBaseMapText: '底图选择',
    mapStyleText: '地图风格',
    TMapText: '天地图',
    AMapText: '高德地图',
    BMapText: '百度地图',
    TencentMapText: '腾讯地图',

    wxMapLayerText: '影像图',
    slMapLayerText: '矢量图',
    darkStyleText: '暗色',
    blueDarkStyleText: '蓝黑版',
    communityStyleText: '彩色版',
    warmStyleText: '暖色版',
    grayStyleText: '灰色版',

    legendText: '图例',
};

export default defaultTextEnum;
